export const TI_ARTIST_SLUGS = ['rick-trip', 'rich-pineda', 'brian', 'sophia-mae', 'dr-valerio', 'casso', 'chris'];
